<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8">
        <h3 class="m-4">Modelos de riesgo</h3>
      </div>
      <div class="col-md-4">
        <vs-button class="float-right m-4">
          Crear nuevo modelo
        </vs-button>
      </div>
    </div>


    <vs-card title="Modelos de Riesgo">
      <vs-table :data="riskModels" stripe>
        <template slot="thead">
          <vs-th>Id</vs-th>
          <vs-th>Nombre</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="riskModel in data">
            <vs-td>{{ riskModel.id }}</vs-td>
            <vs-td>
              <router-link :to="`/risk-model/admin/${riskModel.id}/versions`">
                {{ riskModel.description }}
              </router-link>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
export default {
  name: "Index",
  data: () => ({
    riskModels: []
  }),
  async mounted() {
    let response = await axios.get("/api/risk-model")
    this.riskModels = response.data;
  }
}
</script>

<style scoped>

</style>
